"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)({
  tooltip: {
    maxWidth: 384
  },
  popper: {
    marginBottom: -10,
    '& > .MuiTooltip-tooltip': {
      fontSize: 14,
      padding: '14px 16px 18px',
      marginTop: 8
    }
  }
}, {
  name: 'Tooltip'
});
exports.useStyles = useStyles;